import { CoachIcon, UserIcon } from '../icons/Icons'
import styles from './Message.module.css'

export interface MessageProps {
  type: 'ai' | 'user'
  content: string
  time: string
}

export function Message({ type, content, time }: MessageProps) {
  const isAI = type === 'ai'

  return (
    <div className={`${styles.message} ${isAI ? styles.ai : styles.user}`}>
      <div className={styles.avatar}>
        {isAI ? (
          <CoachIcon className={styles.icon} />
        ) : (
          <UserIcon className={styles.icon} />
        )}
      </div>
      <div className={styles.group}>
        <div className={styles.bubble}>{content}</div>
        <div className={styles.time}>{time}</div>
      </div>
    </div>
  )
}
